import { render, staticRenderFns } from "./PaltenCodeModal.vue?vue&type=template&id=40b00204&"
import script from "./PaltenCodeModal.vue?vue&type=script&lang=js&"
export * from "./PaltenCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports